import {Component, forwardRef, Injector, Input} from "@angular/core";
import {AbstractEditControlComponent} from "../../../entity/edit/edit-controls/abstract-edit-control.component";
import {NG_VALUE_ACCESSOR} from "@angular/forms";

const CUSTOM_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => EntityAvailabilityEditControlComponent),
    multi: true
};


@Component({
    selector: "wbo-entity-availability-edit-control",
    templateUrl: "entity-availability-edit-control.component.html",
    providers: [CUSTOM_VALUE_ACCESSOR]
})
export class EntityAvailabilityEditControlComponent extends AbstractEditControlComponent {
    @Input() negative: string;
    @Input() positive: string;

    constructor(injector: Injector) {
        super(injector);
    }
}
